export enum MemberRole {
  EDITOR = 'EDITOR',
  ADMIN = 'ADMIN',
}

export interface MemberSchemaType {
  name: string;
  addr: string;
  role: MemberRole;
  isActive: boolean;
}

export interface GetMembersResponseSchemaType {
  status: number;
  code: number;
  data: MemberSchemaType[];
}

export interface MemberResponseSchemaType {
  status: number;
  code: number;
  message: string;
  data: MemberSchemaType;
}

export interface CreateMemberRequestType {
  name: string;
  addr: string;
  role: MemberRole;
  isActive: boolean;
}

export interface UpdateMemberRequestType extends CreateMemberRequestType {
  programId: string;
  memberAddr: string;
}

export interface DeleteMemberRequestType {
  programId: string;
  memberAddr: string;
}

export interface GetMembersRequestType {
  programId: string;
  page?: number;
  size?: number;
}
